<template>
  <div class="highlight-container" v-html="highlightText"></div>
</template>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.highlight-container {
  white-space: pre-wrap;

  :deep(.highlight) {
    padding: 2px 0;
    color: #fff;
  }

  :deep(.highlight-primary) {
    background-color: $primary-color;
  }

  :deep(.highlight-success) {
    background-color: $success-color;
  }

  :deep(.highlight-danger) {
    background-color: $danger-color;
  }

  :deep(.highlight-warning) {
    background-color: $warning-color;
  }

  :deep(.highlight-info) {
    background-color: rgba($info-color, 0.8);
  }

  :deep(.highlight-link) {
    padding: 0;
    color: $link-color;
    cursor: pointer;
  }

  :deep(.highlight-link:hover) {
    text-decoration: underline;
  }
}
</style>
<script lang="ts">
import { defineComponent, PropType } from 'vue'

import Highlight from '@/client/core/highlight'

type HighlightRule = { type: string; keywords: string[] }

export default defineComponent({
  props: {
    text: {
      type: String,
      default: ''
    },
    highlights: {
      type: Array as PropType<HighlightRule[]>
    }
  },
  computed: {
    highlightText(): string {
      // getHighlightText は未指定と空配列を同じく扱う
      return Highlight.getHighlightText(this.highlights ?? [], this.text)
    }
  }
})
</script>
